import { Link, useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import InsurersFields from './insurersFields';
import axiosClient from '../../../../config/axios.js';


function NewInsurance() {
    const navigate = useNavigate();
    const { Formik } = formik;

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Configuración</li>
                        <li className="breadcrumb-item"><Link to="/catalogs/insurers">Aseguradoras</Link></li>
                        <li className="breadcrumb-item active">Nueva Aseguradora</li>
                    </ol>
                    <h1 className="page-header mb-0">Registro de nueva Aseguradora</h1>
                </div>
            </div>



            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Registro de nueva Aseguradora</PanelHeader>
                        <PanelBody>
                            <Formik
                                validationSchema={yup.object().shape({
                                    insurance_name: yup.string().required("Ingrese el nombre de la Aseguradora"),
                                    costo_km: yup.number().required("Ingrese el costo por kilometraje"),
                                    banderazo: yup.number().required("Ingrese el banderazo"),
                                    insuranceContacts: yup.array().of(
                                        yup.object().shape({
                                            name: yup.string().required('Favor de escribir el nombre'),
                                            position: yup.string().required('Favor de escribir el puesto'),
                                            phone: yup.string().required('Favor de escribir el número telefónico de contacto'),
                                        })
                                    ),
                                    typeEvidences: yup.array().of(
                                        yup.object().shape({
                                            evidence: yup.object().required('Selecciona el Tipo de evidencia'),
                                        })
                                    ),
                                })}
                                onSubmit={(values, { setSubmitting }) => {
                                    setSubmitting(false);
                                    axiosClient.post('/insurers/save', values).then(response => {

                                        Swal.fire({
                                            title: 'Registro exitoso.',
                                            text: 'Se ha registrado la nueva Aseguradora',
                                            icon: 'success',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                        navigate('/catalogs/insurers');
                                    }).catch(err => {
                                       // console.log(err.response.data);
                                        Swal.fire({
                                            title: 'Ups!',
                                            text: err.response.data.message,
                                            icon: 'error',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                    });
                                }}
                                initialValues={{
                                    insurance_name: '',
                                }}
                            >
                                {({ handleSubmit, handleChange, handleBlur, values, touched, errors, setFieldValue, setFieldTouched }) => (

                                    <Form noValidate onSubmit={handleSubmit}>
                                        <InsurersFields
                                            handleSubmit={handleSubmit}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                        />

                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Button type="submit">Guardar Aseguradora</Button>{' '}
                                                <Link to={'/catalogs/insurers'} className="btn btn-info">Cancelar</Link>
                                            </Col>
                                        </Row>
                                    </Form>

                                )}
                            </Formik>

                        </PanelBody>
                    </Panel>
                </div>

            </div>


        </div>

    );
}

export default NewInsurance;